// extracted by mini-css-extract-plugin
export default {"wrapper":"TutorLessonFooter_wrapper__DcH5K"};